// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","left":"Footer_left__aLZA+","logo":"Footer_logo__+JiYo","right":"Footer_right__ts+rg","subscribe":"Footer_subscribe__TLKCf"};